import { render, staticRenderFns } from "./BtnCancelarSolicitacao.vue?vue&type=template&id=658886f9"
import script from "./BtnCancelarSolicitacao.vue?vue&type=script&lang=js"
export * from "./BtnCancelarSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports